var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupHyperWordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 17,
    viewBox: "0 0 98 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4999 5.63701L23.3235 0H16.9399L24.7961 11.5223V16.3151H30.1969V11.5223L38.0907 0H31.7071L27.4999 5.63701Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3014 0H38.8647V16.3151H44.2655V13.0069H50.4881C52.1696 13.0069 57.3254 12.298 57.3254 6.25859C57.3254 0.219182 51.8408 0 50.3014 0ZM50.1302 8.20209H44.2655V4.80311H50.0377C50.7963 4.80311 52.2723 4.85961 52.2723 6.43839C52.2723 8.01716 50.959 8.20209 50.1302 8.20209Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5374 16.3154H76.5272V11.7897H63.9381V10.3222H75.7292V5.97799H63.9381V4.53449H76.5272V0.012207H58.5374V16.3154Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2557 11.5001C95.8396 10.6439 97.2471 9.01374 97.2471 5.99318C97.2471 0.207193 91.7677 0 90.2266 0H78.2556V16.3151H83.6563V12.4538H88.5673L91.3344 16.286L97.5879 16.3134L94.2557 11.5001ZM89.7163 7.6901H83.6563V4.76372H89.629C90.343 4.76372 91.7351 4.81338 91.7351 6.17298C91.7351 7.53257 90.4971 7.6901 89.7163 7.6901Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84731 0.00866699H0.412354V5.44362H5.84731V0.00866699Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84731 10.8804H0.412354V16.3153H5.84731V10.8804Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84741 5.44373V10.8787H11.2824V16.3153H16.7173V10.8787V5.44373H11.2824H5.84741Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupHyperWordIcon);
export default __webpack_public_path__ + "static/media/group_hyper_word_icon.fc1a2b1d826776a8e2a6b77c3f0abd03.svg";
export { ForwardRef as ReactComponent };